module.exports = __webpack_public_path__ + "static/media/icon.300e69ff.png";